import { CommonModule, NgComponentOutlet } from '@angular/common';
import { Component, computed, input, Signal, Type } from '@angular/core';
import { CwButton, CwDialog } from '@bbraun/cortex-angular';
import { TranslateModule } from '@ngx-translate/core';
import { AbortModalComponent } from '~/app/components/abort-modal/abort-modal.component';
import { ConfirmUnpreparedModalComponent } from '~/app/components/confirm-unprepared-modal/confirm-unprepared-modal.component';
import { ContextModalComponent } from '~/app/components/context-modal/context-modal.component';
import { EditOrganizationSettingsModalComponent } from '~/app/components/edit-organization-settings-modal/edit-organization-settings-modal.component';
import { FinalizeJobModalComponent } from '~/app/components/finalize-job-modal/finalize-job-modal.component';
import { ForceUnpairModalComponent } from '~/app/components/force-unpair-modal/force-unpair-modal.component';
import { ParamsEditModalComponent } from '~/app/components/params-edit-modal/params-edit-modal.component';
import { PreparedEditModalComponent } from '~/app/components/prepared-edit-modal/prepared-edit-modal.component';
import { DialogIds } from '~/app/constants/Dialogs';
import { CustomShadowCssDirective } from '~/app/directives/CustomShadowCss';
import { Dialog } from '~/app/services/dialog.service';

@Component({
  selector: 'gplus-modal-container',
  imports: [CwDialog, NgComponentOutlet, TranslateModule, CommonModule, CwButton, CustomShadowCssDirective],
  templateUrl: './modal-container.component.html',
  styleUrl: './modal-container.component.scss'
})
export class ModalContainerComponent {
  public dialog = input<Dialog>(null);

  // The id→component map lives in the UI layer so the service layer never imports modal components.
  private readonly componentMap: Map<DialogIds, Type<unknown>> = new Map<DialogIds, Type<unknown>>([
    [DialogIds.CONTEXT_SELECTOR, ContextModalComponent],
    [DialogIds.ABORT, AbortModalComponent],
    [DialogIds.FINALIZE_JOB, FinalizeJobModalComponent],
    [DialogIds.EDIT_PREPARATION_TIME, PreparedEditModalComponent],
    [DialogIds.EDIT_ORGANIZATION_SETTINGS, EditOrganizationSettingsModalComponent],
    [DialogIds.EDIT_THERAPY_JOB_PARAMS, ParamsEditModalComponent],
    [DialogIds.CONFIRM_UNPREPARED, ConfirmUnpreparedModalComponent],
    [DialogIds.FORCE_UNPAIR, ForceUnpairModalComponent]
  ]);

  public readonly dialogComponent: Signal<Type<unknown> | null> = computed(() => {
    const id = this.dialog()?.id;
    return id ? (this.componentMap.get(id) ?? null) : null;
  });

  private readonly baseDialogStyles = '.dialog-footer{padding:0!important}';

  public readonly dialogStyles: Signal<string> = computed(() => {
    const id = this.dialog()?.id;
    return id === DialogIds.FINALIZE_JOB ? `${this.baseDialogStyles}.dialog{width:42.625rem!important}` : this.baseDialogStyles;
  });

  public clickOutside(): void {
    if (this.dialog()?.closeOnClickOutside) {
      this.dialog()?.confirm.next(false);
    }
  }
}
